//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUpload from '@/components/CFileUpload'
import { Divider } from 'vant'

export default {
  components: {
    FileUpload,
    Divider,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    noTitle: {
      type: Boolean,
      default: false,
    },

    abs: { type: String },

    content: {
      type: String,
      default: '',
    },

    attach: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return { }
  },

  computed: {},

  created () {
  },

  methods: {
    filterContent () {
      return this.content.replace(/(\d*\.?\d+)(pt|px)(;?)/g, (val, $1, $2, $3) => {
        const px = parseFloat($1)

        if (px <= 1) {
          return val
        }

        if ($2 === 'px') {
          return `${(px / 16).toFixed(5)}rem${$3}`

          // return ($1 / 505 * 100).toFixed(5) + 'vw' + $3
        } else {
          return `${(px / 16).toFixed(5)}rem${$3}`

          // return ($1 / 375 * 100).toFixed(5) + 'vw' + $3
        }
      })
    },
  },
}
